import { AnimatePresence } from 'framer-motion';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AppFooter from './components/shared/AppFooter';
import AppHeader from './components/shared/AppHeader';
import './css/App.css';
import UseScrollToTop from './hooks/useScrollToTop';

const Error = lazy(() => import('./pages/Error'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Home = lazy(() => import('./pages/Home'));
const Projects = lazy(() => import('./pages/Projects'));
const ProjectTracker = lazy(() => import ('./pages/ProjectTracker'));
const ProjectChallah = lazy(() => import('./pages/ProjectChallah'));
const ProjectDiscord = lazy(() => import('./pages/ProjectDiscord'));
const ProjectStream = lazy(() => import('./pages/ProjectStream'));
const ProjectTwitch = lazy(() => import('./pages/ProjectTwitch'));
const ProjectUnity = lazy(() => import('./pages/ProjectUnity'));
const ProjectClub = lazy(() => import('./pages/ProjectClub'));


function App() {
	return (
		<AnimatePresence>
			<div className="bg-secondary-light dark:bg-primary-dark transition duration-300">
				<Router>
					<ScrollToTop />
					<AppHeader />
					<Suspense fallback={""}>
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="projects" element={<Projects />} />
							<Route path="projects/game-tracker" element={<ProjectTracker />} />
							<Route path="projects/unity-performance" element={<ProjectUnity />} />
							<Route path="projects/discord-bot" element={<ProjectDiscord />} />
							<Route path="projects/stream-deck" element={<ProjectStream />} />
							<Route path="projects/twitch-bot" element={<ProjectTwitch />} />
							<Route path="projects/challahland" element={<ProjectChallah />} />
							<Route path="projects/maker-club" element={<ProjectClub />} />
							<Route path="about" element={<About />} />
							<Route path="contact" element={<Contact />} />
							<Route path="*" element={<Error />} />
						</Routes>
					</Suspense>
					<AppFooter />
				</Router>
				<UseScrollToTop />
			</div>
		</AnimatePresence>
	);
}

export default App;
